import { Alert } from "rsuite";

import { ALERT_DISPLAY_DURATION } from "const";

Alert.config({ duration: ALERT_DISPLAY_DURATION });